/* eslint-disable no-undef */
export class Equipment {
  constructor (width, height, origin, projection) {
    this.width = width * this.FEET_TO_METERS()
    this.height = height * this.FEET_TO_METERS()
    this.projection = projection

    this.calculateDefaultLocation(origin)
    this.originPoint = this.calculateCenterPoint()
  }

  points () {
    return [this.topLeft, this.topRight, this.bottomRight, this.bottomLeft]
  }

  calculateCenterPoint () {
    const bounds = new google.maps.LatLngBounds()
    this.points().forEach((point) => bounds.extend(point))

    return bounds.getCenter()
  }

  calculateDefaultLocation (origin) {
    this.topLeft = origin

    this.topRight = google.maps.geometry.spherical.computeOffset(
      this.topLeft,
      this.width,
      90
    )

    this.bottomRight = google.maps.geometry.spherical.computeOffset(
      this.topRight,
      this.height,
      180
    )

    this.bottomLeft = google.maps.geometry.spherical.computeOffset(
      this.topLeft,
      this.height,
      180
    )
  }

  setPoints (points) {
    this.topLeft = points[0]
    this.topRight = points[1]
    this.bottomRight = points[2]
    this.bottomLeft = points[3]

    this.originPoint = this.calculateCenterPoint()
  }

  rotate (deg) {
    this.topLeft = this.rotatePoint(this.topLeft, deg)
    this.topRight = this.rotatePoint(this.topRight, deg)
    this.bottomRight = this.rotatePoint(this.bottomRight, deg)
    this.bottomLeft = this.rotatePoint(this.bottomLeft, deg)

    this.originPoint = this.calculateCenterPoint()
  }

  rotatePoint (point, deg) {
    const originCoordinate = this.projection.fromLatLngToPoint(this.originPoint)
    const pointCoordinate = this.projection.fromLatLngToPoint(point)

    const angleRad = deg * Math.PI / 180.0

    const rotatedPoint = {
      x: Math.cos(angleRad) * (pointCoordinate.x - originCoordinate.x) - Math.sin(angleRad) * (pointCoordinate.y - originCoordinate.y) + originCoordinate.x,
      y: Math.sin(angleRad) * (pointCoordinate.x - originCoordinate.x) + Math.cos(angleRad) * (pointCoordinate.y - originCoordinate.y) + originCoordinate.y
    }

    return this.projection.fromPointToLatLng(rotatedPoint)
  }

  FEET_TO_METERS () {
    return 0.3048
  }
}
